// ==============================|| OVERRIDES - TAB ||============================== //

import type { Theme } from '@mui/material';

export default function Tab<T extends Theme>(theme: T) {
    return {
        MuiTab: {
            styleOverrides: {
                root: {
                    minHeight: 46,
                    color: theme.palette.text.primary,
                },
            },
        },
    };
}
